import { type BootstrapData, BOOTSTRAP_SCHEMA_VERSION } from '@/types/bootstrap';

export function readBootstrap(): BootstrapData | null {
  const el = document.getElementById('app-bootstrap');
  if (!el?.textContent) return null;
  try {
    const data = JSON.parse(el.textContent) as BootstrapData;
    if (data.schemaVersion !== BOOTSTRAP_SCHEMA_VERSION) return null;
    return data;
  } catch {
    return null;
  }
}
